module.exports = __webpack_public_path__ + "img/ku1_act.035bc9bc.png";